import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyOverview from "./sections/PrivacyOverview";
import DataCollectionAndUse from "./sections/DataCollectionAndUse";
import UserRightsAndContact from "./sections/UserRightsAndContact";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyOverview />
      <DataCollectionAndUse />
      <UserRightsAndContact />
      <Footer />
    </div>;
}